import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FacebookCapiModalContainer from 'AdsUI/containers/announcements/FacebookCapiModalContainer';
/**
 * Announcements shown to the user regardless of what page they're on.
 */

const GlobalAnnouncements = () => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(FacebookCapiModalContainer, {})
  });
};

export default GlobalAnnouncements;